import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import './AdminPages.css';

const Settings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    site_name: '',
    site_description: '',
    whatsapp_number: '',
    phone: '',
    address: '',
    email: '',
    working_hours: '',
    facebook_url: '',
    instagram_url: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.getSettings();
      setFormData(response.data);
    } catch (err) {
      console.error('Error fetching settings:', err);
      alert('فشل تحميل الإعدادات');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await adminAPI.updateSettings(formData);
      alert('تم حفظ الإعدادات بنجاح');
    } catch (err) {
      console.error('Error saving settings:', err);
      alert('فشل حفظ الإعدادات');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>إعدادات الموقع</h1>
      </div>

      <div className="admin-form-container">
        <form onSubmit={handleSubmit} className="admin-form">
          <div className="form-group">
            <label>اسم الموقع *</label>
            <input
              type="text"
              name="site_name"
              value={formData.site_name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>وصف الموقع</label>
            <textarea
              name="site_description"
              value={formData.site_description}
              onChange={handleInputChange}
              rows="4"
            />
          </div>

          <div className="form-group">
            <label>رقم الواتساب *</label>
            <input
              type="text"
              name="whatsapp_number"
              value={formData.whatsapp_number}
              onChange={handleInputChange}
              required
              placeholder="+218XXXXXXXXX"
            />
          </div>

          <div className="form-group">
            <label>رقم الهاتف</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="+218XXXXXXXXX"
            />
          </div>

          <div className="form-group">
            <label>العنوان</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>البريد الإلكتروني</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>ساعات العمل</label>
            <input
              type="text"
              name="working_hours"
              value={formData.working_hours}
              onChange={handleInputChange}
              placeholder="مثال: السبت - الخميس: 9:00 صباحاً - 6:00 مساءً"
            />
          </div>

          <div className="form-group">
            <label>رابط فيسبوك</label>
            <input
              type="url"
              name="facebook_url"
              value={formData.facebook_url}
              onChange={handleInputChange}
              placeholder="https://www.facebook.com/..."
            />
          </div>

          <div className="form-group">
            <label>رابط انستغرام</label>
            <input
              type="url"
              name="instagram_url"
              value={formData.instagram_url}
              onChange={handleInputChange}
              placeholder="https://www.instagram.com/..."
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Settings;
